var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorporateAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BBA262",
    d: "M16 0c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4h12zm0 .667H4C2.207.667.745 2.082.67 3.855L.667 4v12c0 1.793 1.415 3.255 3.188 3.33l.145.003h12c1.793 0 3.255-1.415 3.33-3.188l.003-.145V4c0-1.793-1.415-3.255-3.188-3.33L16 .667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A19",
    d: "M5.957 12.75l1.664-5.337h-.8L5.573 11.51 4.35 7.413H3.333l1.648 5.336h.976zm4.12.08c1.12 0 1.856-.673 2.024-1.833l-.896-.104c-.08.712-.544 1.128-1.056 1.128-.712 0-1.168-.68-1.168-1.96 0-1.24.4-1.952 1.136-1.952.552 0 .904.336 1.088 1.208l.896-.096c-.2-1.224-.904-1.888-1.992-1.888-1.376 0-2.168 1.152-2.168 2.728 0 1.416.624 2.768 2.136 2.768zm3.04-.08l.416-1.273h2.048l.432 1.272h1.024l-1.792-5.336H14.07l-1.776 5.336h.824zm2.208-2.04h-1.552l.776-2.385.776 2.384z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateAction);
export default __webpack_public_path__ + "static/media/corporate-action.e88a859c16c18fd5454b9d711a385e2e.svg";
export { ForwardRef as ReactComponent };